/* Cart — AJAX add, drawer, quantity, remove.
   Uses Shopify's section rendering so the drawer and the cart page always agree.
   Every path degrades: with JS off the product form posts normally to /cart. */
(function () {
  'use strict';

  var html = document.documentElement;

  // The drawer is a static section so its id is fixed. The cart page lives in a
  // JSON template, where Shopify generates the id, so we read it off the markup.
  function sectionIds() {
    var ids = [];
    if (document.getElementById('shopify-section-wn-cart-drawer')) ids.push('wn-cart-drawer');
    var page = document.querySelector('[data-cart-section]');
    if (page) {
      var id = page.getAttribute('data-cart-section');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }
    return ids;
  }

  function swap(id, markup) {
    var target = document.getElementById('shopify-section-' + id);
    if (!target || !markup) return;
    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    var source = parsed.getElementById('shopify-section-' + id);
    target.innerHTML = source ? source.innerHTML : markup;
  }

  function applySections(payload) {
    if (!payload) return;
    Object.keys(payload).forEach(function (id) { swap(id, payload[id]); });
  }

  function setCount(n) {
    var link = document.querySelector('.wn-header__actions a[href$="/cart"]');
    if (!link) return;
    var badge = link.querySelector('.wn-cart-count');
    if (n > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'wn-cart-count';
        link.appendChild(badge);
      }
      badge.textContent = n;
    } else if (badge) {
      badge.remove();
    }
  }

  function busy(state) { html.setAttribute('data-cart-busy', state ? 'true' : 'false'); }

  function open() {
    html.setAttribute('data-cart-open', 'true');
    var close = document.querySelector('[data-cart-close]');
    if (close) { try { close.focus(); } catch (e) {} }
  }
  function close() { html.setAttribute('data-cart-open', 'false'); }

  function showError(message) {
    var slot = document.querySelector('[data-cart-error]');
    if (slot) { slot.textContent = message; slot.hidden = false; }
    else window.alert(message);
  }

  /* ---- Klaviyo "Added to Cart" (15 Oct 2026) ----
     Klaviyo's Shopify app records "Viewed Product" on its own, but "Added to
     Cart" has to be sent by the theme, and this cart adds by AJAX so Klaviyo
     never saw one. Sent after /cart/add.js succeeds, in the shape Klaviyo's
     abandoned-cart flow expects. Only identified browsers (someone Klaviyo
     already knows) produce a profile event; that is how Klaviyo works. Fails
     silently: nothing here can stop the add itself. */
  function trackKlaviyoAdd(added, cart) {
    try {
      if (!added || !cart) return;
      var origin = window.location.origin;
      var money = function (c) { return Math.round((c || 0)) / 100; };
      var lines = (cart.items || []).map(function (i) {
        return {
          ProductID: i.product_id, SKU: i.sku, ProductName: i.product_title,
          Quantity: i.quantity, ItemPrice: money(i.price), RowTotal: money(i.line_price),
          ProductURL: origin + i.url, ImageURL: i.image
        };
      });
      var payload = {
        $value: money(cart.total_price),
        AddedItemProductName: added.product_title,
        AddedItemProductID: added.product_id,
        AddedItemSKU: added.sku,
        AddedItemCategories: [],
        AddedItemImageURL: added.image,
        AddedItemURL: origin + added.url,
        AddedItemPrice: money(added.price),
        AddedItemQuantity: added.quantity,
        ItemNames: lines.map(function (l) { return l.ProductName; }),
        CheckoutURL: origin + '/cart',
        Items: lines
      };
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', 'Added to Cart', payload]);
    } catch (e) {}
  }

  /* ---- add to cart ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();

    // Every submit button in this form, not just the first: the product page
    // now has two (the in-page one and the sticky mobile buy bar's), and
    // whichever was tapped should be the one that reads "Adding...".
    var buttons = [];
    var labels = [];
    form.querySelectorAll('[type=submit]').forEach(function (b) {
      buttons.push(b);
      labels.push(b.textContent);
      b.setAttribute('aria-disabled', 'true');
      b.textContent = 'Adding...';
    });

    var data = new FormData(form);
    var ids = sectionIds();
    if (ids.length) data.append('sections', ids.join(','));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          showError((res.body && res.body.description) || 'That piece could not be added.');
          return;
        }
        applySections(res.body.sections);
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { setCount(cart.item_count); open(); trackKlaviyoAdd(res.body, cart); });
      })
      .catch(function () { showError('Something went wrong. Please try again.'); })
      .finally(function () {
        buttons.forEach(function (b, i) {
          b.removeAttribute('aria-disabled');
          b.textContent = labels[i];
        });
      });
  });

  /* ---- change a line ---- */
  function change(line, quantity) {
    busy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionIds().join(',') })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        applySections(cart.sections);
        setCount(cart.item_count);
      })
      .catch(function () { showError('We could not update your bag. Please try again.'); })
      .finally(function () { busy(false); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    // The bag icon opens the drawer rather than leaving the page.
    var bag = t.closest('.wn-header__actions a[href$="/cart"]');
    if (bag) { e.preventDefault(); open(); return; }

    if (t.closest('[data-cart-open-btn]')) { e.preventDefault(); open(); return; }
    if (t.closest('[data-cart-close]') || t.closest('[data-cart-scrim]')) { e.preventDefault(); close(); return; }

    var step = t.closest('[data-cart-step]');
    if (step) {
      e.preventDefault();
      var wrap = step.closest('[data-line]');
      var input = wrap.querySelector('[data-cart-qty]');
      var current = parseInt(input.value, 10) || 0;
      var nextVal = step.getAttribute('data-cart-step') === 'up' ? current + 1 : current - 1;
      if (nextVal < 0) nextVal = 0;
      change(parseInt(wrap.getAttribute('data-line'), 10), nextVal);
      return;
    }

    var remove = t.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      var row = remove.closest('[data-line]');
      change(parseInt(row.getAttribute('data-line'), 10), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var row = input.closest('[data-line]');
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    change(parseInt(row.getAttribute('data-line'), 10), q);
  });

  /* ---- order note ---- */
  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 600);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && html.getAttribute('data-cart-open') === 'true') close();
  });
})();
